import React, { PureComponent, Fragment } from "react";
import withErrorCatcher from '../../Common/withErrorCatcher.js'
import { withStyles, TextField, Input, InputLabel } from "@material-ui/core";
import MaskedInput from 'react-text-mask';
import PropTypes from "prop-types";

const styles = theme => ({

})

function TextMaskCustom(props) {
    const { inputRef, mask, ...other } = props;
    return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={mask}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  }

  TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
  };

class PhoneInput extends PureComponent {
    
    defaultMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

    render(){
        const { onChange, fieldMapping, value, classes, label, mask } = this.props

        return(
          <Fragment>
            {
              label ? <InputLabel htmlFor='formatted-numberformat-input'>{label} </InputLabel> : null
            }
            <TextField
            className={classes.container}
            label
            value={value}
            fullWidth
            onChange={onChange}
            id="formatted-numberformat-input"
            InputProps={{
                inputProps:{mask: mask || this.defaultMask},
                inputComponent: TextMaskCustom,
                dir:'auto'
            }}
        />
            </Fragment>
        )
        return <TextField
            className={classes.container}
            label
            value={value}
            fullWidth
            onChange={onChange}
            id="formatted-numberformat-input"
            InputProps={{
                inputProps:{mask: mask || this.defaultMask},
                inputComponent: TextMaskCustom,
                dir:'auto'
            }}
        />
    }
}

export default withStyles(styles)(PhoneInput);


